import { render } from "./DTEmailSubmit.vue?vue&type=template&id=67ecc895&scoped=true"
import script from "./DTEmailSubmit.vue?vue&type=script&lang=js"
export * from "./DTEmailSubmit.vue?vue&type=script&lang=js"

import "./DTEmailSubmit.vue?vue&type=style&index=0&id=67ecc895&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ecc895"]])

export default __exports__